// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__1lOrl","label":"LabeledBox_label__J9ifS"};